//@flow
import { fetchQuery, graphql } from 'react-relay';

const query = graphql`
    query zipCodeLookupQuery($zipCode: String!, $country: String!) {
        viewer {
            zipCode(zipCode: $zipCode, country: $country) {
                city
                state
                country
            }
        }
    }
`;

type ZipCodeLookupArgs = {
    zipCode: string,
    country: string,
};

export const zipCodeLookup = (environment: Object, args: ZipCodeLookupArgs) => {
    const variables = {
        zipCode: args.zipCode,
        country: args.country,
    };
    return fetchQuery(environment, query, variables);
};
